import { GrowthBook } from '@growthbook/growthbook-react'
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins'

export const initGrowthBookClient = () => {
  return new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY ?? '',
    enableDevMode: process.env.NODE_ENV === 'development',
    plugins: typeof window === 'undefined' ? [] : [autoAttributesPlugin()],
  })
}
